import { isWithinInterval, startOfDay } from 'date-fns';

export const isDateBlocked = (date, blockedDates = [], availablePeriods = []) => {
  const isWithinBlockedDates = blockedDates.some(({ start_date, end_date }) =>
    isWithinInterval(date, {
      start: startOfDay(new Date(start_date)),
      end: startOfDay(new Date(end_date))
    })
  );

  const isWithinAvailablePeriods = availablePeriods.some(({ start_date, end_date }) =>
    isWithinInterval(date, {
      start: startOfDay(new Date(start_date)),
      end: startOfDay(new Date(end_date))
    })
  );

  return isWithinBlockedDates || !isWithinAvailablePeriods;
};
